let searchBar = document.getElementById('content-search');
let doSearch = document.getElementById('do-search');
let clearSearch = document.getElementById('clear-search');
let resultContainer = document.getElementById('result-container');

let jsonList = [];
const loadjsonListItems = async(JSONurl) => {
    try {
        const res = await fetch(JSONurl);
        jsonList = await res.json();
        displayList(jsonList);

        //For the depot Finder List
        const swiper = new Swiper('.depot-swiper', {
            direction: 'vertical',
            loop: false,
            slidesPerView: 'auto',
            a11y: true,
            grabCursor: true,
            mousewheel: true,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },

            navigation: {
                nextEl: `.button-next-depot-swiper`,
                prevEl: `.button-prev-depot-swiper`,
            },

        });

    } catch (err) {
        console.error(err);
    }
};

if (typeof(doSearch) != 'undefined' && doSearch != null) {
    doSearch.onclick = function() {
        resultContainer.scrollIntoView({
            behavior: "auto"
        });
    };
}

if (typeof(clearSearch) != 'undefined' && clearSearch != null) {
    clearSearch.onclick = function() {
        searchBar.value = '';
        displayList(jsonList);
        this.style.display = "none";
    };
}

if (typeof(searchBar) != 'undefined' && searchBar != null) {
    searchBar.addEventListener('keyup', (e) => {

        const searchString = e.target.value.toLowerCase();

        if (e.key === 'Enter') {
            resultContainer.scrollIntoView({
                behavior: "auto"
            });
            return;
        }


        if (e.target.value) {
            clearSearch.style.display = "inline-flex";
        } else {
            clearSearch.style.display = "none";
        }


        setTimeout(() => {
            if (!resultContainer.hasChildNodes()) {
                const noResults = document.createElement("p");
                noResults.classList.add('no-results');
                noResults.textContent = 'Sorry, no results match your search...';
                resultContainer.appendChild(noResults);
            }
        }, 100);



        const filteredList = jsonList.filter((jsonListItem) => {
            let searchableContent = '';
            searchableContent += jsonListItem.title.toLowerCase();
            searchableContent += ' ';
            if(jsonListItem.children){
                for (var i = 0, l = jsonListItem.children.length; i < l; i++) {
                    searchableContent += jsonListItem.children[i].title.toLowerCase();
                    searchableContent += ' ';
                }
            }
            return (
                searchableContent.includes(searchString)
            );
        });

        displayList(filteredList);

    });
}


const displayList = (jsonListItems) => {
    const htmlString = jsonListItems.map(
        (jsonListItem) => {
            let html = `Empty`;
            if(jsonListItem.content_type == 'depot'){
                html = `
                <div class="swiper-slide depot-slide" data-primary="" data-slug="${jsonListItem.slug}">
                        <div tabindex="0" data-slug="${jsonListItem.slug}" class="depot-location">
                        ${jsonListItem.title}
                        </div>
                        <div>
                            <i class="sj--icon-phone"></i><a href="tel:${jsonListItem.tel}"><span>${jsonListItem.tel}</span></a>
                        </div>
                    
                </div>
                `;
            }
            else if(jsonListItem.content_type == 'machinery'){

                if(jsonListItem.children && jsonListItem.children.length){
                    let targetvalue = '';
                    if(jsonListItem.isexternal == true){
                        targetvalue = '_blank'
                    }
                    const openTags = `
                    <div class="col-50">
                        <article class="machinery-card has-children">
                            <div class="inner-container">
                                <figure>
                                    <img loading="lazy" src="${jsonListItem.thumbnail}">
                                </figure>
                                <div class="machinery-card-content">
                                    <h3>${jsonListItem.title}</h3>
                                </div>
                                <div class="sj-button sj-yellow">
                                    <a href="${jsonListItem.slug}" class="sj-button-link" target="${targetvalue}" rel= "noopener">
                                        <span>View All</span>
                                        <i class="sj--icon-double-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="child-container">
                                <hr>
                                <div class="accordion-container">
                                    <details class="ac">
                                        <summary class="ac-header">
                                            <h4 class="ac-trigger">View ${jsonListItem.singular_name} Types</h4>
                                        </summary>
                                        <div class="ac-panel">
                                            <div class="inner-panel-container">`;   
                                            
                                            let children = '';

                                            for (var i = 0, l = jsonListItem.children.length; i < l; i++) {
                                                let childtargetvalue = '';
                                                if(jsonListItem.children[i].isexternal == true){
                                                    childtargetvalue = '_blank'
                                                }
                                                const childCard = `
                                                <a href="${jsonListItem.children[i].slug}" class="child-machinery-card" target="${childtargetvalue}" rel= "noopener">
                                                    <figure>
                                                        <img loading="lazy" src="${jsonListItem.children[i].thumbnail}">
                                                    </figure>
                                                    <h5>${jsonListItem.children[i].title}</h5>
                                                    <i class="sj--icon-double-arrow-right"></i>
                                                </a>
                                                `;
                                                children += childCard;
                                            }
                                            
                                            const endTags = `
                                            </div>
                                        </div>
                                    </details>
                                </div>
                            </div>
                        </article>
                    </div>`;

                    html = openTags + children + endTags;
                } else {
                    let targetvalue = '';
                    if(jsonListItem.isexternal == true){
                        targetvalue = '_blank'
                    }
                    html = `
                    <div class="col-50">
                        <article class="machinery-card">
                            <div class="inner-container">
                                <figure>
                                    <img loading="lazy" src="${jsonListItem.thumbnail}">
                                </figure>
                                <div class="machinery-card-content">
                                    <h3>${jsonListItem.title}</h3>
                                </div>
                                <div class="sj-button  sj-yellow">
                                    <a href="${jsonListItem.slug}" class="sj-button-link" target="${targetvalue}" rel= "noopener">
                                        <span>View All</span>
                                        <i class="sj--icon-double-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </article>
                    </div>
                    `;
                }
            } else if(jsonListItem.content_type == 'contact'){
                html = `
                <div class="depot-contact-box">
                    <h3 class="depot-title">${jsonListItem.title}</h3>
                    <hr>
                    <div class="depot-info">
                        <div class="depot-tel depot-info-item">
                            <i class="sj--icon-phone"></i>
                            <span class="depot-tel-value">${jsonListItem.tel}</span>
                        </div>
                        
                        <div class="depot-email depot-info-item">
                            <i class="sj--icon-email"></i>
                            <span class="depot-email-value">${jsonListItem.email}</span>
                        </div>
                        
                        <div class="depot-address depot-info-item">
                            <i class="sj--icon-home"></i>
                            <span class="depot-address-value">${jsonListItem.address}</span>
                        </div>

                        <div class="depot-opening-hours depot-info-item">
                            <div class="depot-monfri depot-info-item">
                                <i class="sj--icon-time"></i>
                                <span class="depot-item-label">Mon - Fri:</span>
                                <span class="depot-mon-fri-value">${jsonListItem.opening_hours.monfri}</span>
                            </div>
                            <div class="depot-sat depot-info-item">
                                <i class="sj--icon-time sj-bw-f4f"></i>
                                <span class="depot-item-label">Sat:</span>
                                <span class="depot-sat-value">${jsonListItem.opening_hours.sat}</span>
                            </div>
                            <div class="depot-sun depot-info-item">
                                <i class="sj--icon-time sj-bw-f4f"></i>
                                <span class="depot-item-label">Sun:</span>
                                <span class="depot-sun-value">${jsonListItem.opening_hours.sun}</span>
                            </div>
                        </div>
                    </div>
                </div>
                `;
            }
            return html;
        }
    ).join('');
    if (typeof(resultContainer) != 'undefined' && resultContainer != null) {
        resultContainer.innerHTML = htmlString;
    }
};